export { default } from './Incomes';
